import {
  AbstractMenuPermissionService,
  type MyreRoute,
} from '@myre/ui-domain-core';

import { Injectable } from '@angular/core';
import { castArray, compact } from 'lodash-es';
import { of, type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuPermissionService extends AbstractMenuPermissionService {
  public hasAccessToRoute$(route: MyreRoute): Observable<boolean> {
    // No permission system in this app yet: only permission-less routes display.
    return of(!compact(castArray(route.data?.permission)).length);
  }
}
